import { Routes, Route, Navigate } from 'react-router-dom'
import ShipperDashboard from '../pages/dashboard/ShipperDashboard'
import QuotesPage from '../pages/QuotesPage'
import QuoteDetailsPage from '../pages/shipper/QuoteDetailsPage'
import NewQuotePageWizard from '../pages/shipper/NewQuotePageWizard'
import OrderDetailsPage from '../pages/shipper/OrderDetailsPage'
import ShipmentsPage from '../pages/shipper/ShipmentsPage'
import DocumentsPage from '../pages/shipper/DocumentsPage'
import OffersPage from '../pages/shipper/OffersPage'
import ReportsPage from '../pages/shipper/ReportsPage'
import SettingsPage from '../pages/shipper/SettingsPage'
import AgentsPage from '../pages/shipper/AgentsPage'
import NotificationsPage from '../pages/NotificationsPage'
import QuoteViewPage from '../pages/shared/QuoteViewPage'
import ShipperControlTowerPage from '../pages/shipper/ControlTowerPage'

export default function ShipperRoutes() {
  return (
    <Routes>
      <Route path="/dashboard" element={<ShipperDashboard />} />
      <Route path="/control-tower" element={<ShipperControlTowerPage />} />
      <Route path="/quotes" element={<QuotesPage />} />
      <Route path="/quotes/new" element={<NewQuotePageWizard />} />
      <Route path="/quotes/:id" element={<QuoteDetailsPage />} />
      <Route path="/quotes/:id/edit" element={<NewQuotePageWizard />} />
      <Route path="/quotes/:id/view" element={<QuoteViewPage />} />
      <Route path="/orders/:id" element={<OrderDetailsPage />} />
      <Route path="/shipments" element={<ShipmentsPage />} />
      <Route path="/documents" element={<DocumentsPage />} />
      <Route path="/offers" element={<OffersPage />} />
      <Route path="/reports" element={<ReportsPage />} />
      <Route path="/settings" element={<SettingsPage />} />
      <Route path="/agents" element={<AgentsPage />} />
      <Route path="/notifications" element={<NotificationsPage />} />

      {/* Redirect /shipper to /shipper/dashboard */}
      <Route path="/" element={<Navigate to="/shipper/dashboard" replace />} />

      {/* 404 within shipper routes */}
      <Route path="*" element={<div>Pagina nao encontrada</div>} />
    </Routes>
  )
}
